import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./SwitchUserDropdown.module.css";

export function SwitchUserDropdown({
  users,
  onSave,
  activeUser,
  isPersonalPage,
}) {
  const [selectedUser, setSelectedUser] = useState(activeUser);

  useEffect(() => {
    setSelectedUser(activeUser);
  }, [activeUser]);

  const handleSave = (user) => {
    if (user) {
      const newUser = {
        ...user,
        name: `${user.firstName} ${user.lastName}`,
        iboLOAInfo: user.iboLOAInfo,
        accountIssues: user.accountIssues,
      };

      onSave(newUser);
    }
  };

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    handleSave(user); // Directly call save when a user is selected
  };

  return (
    <div className={styles.dropdownContainer}>
      <div
        className={
          isPersonalPage ? styles.dropdownMenuPersonalPage : styles.dropdownMenu
        }
      >
        {users.map((user) => (
          <div
            key={user.contactId}
            className={`${styles.user} ${
              selectedUser && selectedUser.contactId === user.contactId
                ? styles.selectedUser
                : ""
            }`}
            onClick={() => handleUserSelect(user)}
          >
            {user.firstName} {user.lastName}
          </div>
        ))}
      </div>
    </div>
  );
}

SwitchUserDropdown.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      contactId: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    })
  ).isRequired,
  onClick: PropTypes.func,
  activeUser: PropTypes.shape({
    contactId: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    iboNum: PropTypes.string,
    iboLOAInfo: PropTypes.array,
    accountIssues: PropTypes.array,
  }),
};

export default SwitchUserDropdown;
